export default function DeliveryAddList() {
    return <div>DeliveryAddList</div>;
}
